<div class="outer" [ngClass]="{'animateIn': triggerAnimation}">
  <div class="inner bg" #bg>
    <div class="content">
      <h1 class="title">SERVICES</h1>
      <ul style="margin: 0; padding: 0;" #content>
        <li *ngFor="let product of products$ | async; trackBy: identify" [ngClass]="{'no-desc': !product.description}">
          <i class="far fa-plus-square" style="cursor: pointer; text-shadow: 2px 2px 5px black;" (click)="moreInfo(product)" *ngIf="product.description"></i>
          <app-product [product]="product" style="width: 100%;"></app-product>
        </li>
      </ul>
    </div>
  </div>
</div>
